import axiosInstance from "../../../api/axiosConfig";

export const getLatestOrders = () => {
  return axiosInstance.get("/admin/dashboard/recent/orders");
};

export const getStockProductsCount = () => {
  return axiosInstance.get("/admin/dashboard/products/count");
};

export const getOrdersCount = () => {
  return axiosInstance.get("/admin/dashboard/orders/count");
};

export const getSampleProductsCount = () => {
  return axiosInstance.get("/admin/dashboard/sample-products/count");
};
